import React from "react"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"

interface AddButtonProps extends CustomButtonProps {}
const AddButton = ({ text, ...otherProps }: AddButtonProps) => {
  return <CustomButton icon="plus" dark text={text} {...otherProps} />
}

export default AddButton
